import { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { motion, AnimatePresence } from "framer-motion";
import { X, ArrowRight, Sparkles } from "lucide-react";

const STORAGE_KEY = "plan-de-match-popup-seen";
const HIDDEN_PREFIXES = ["/plan-de-match", "/plan", "/admin", "/galerie-selection", "/offre", "/videogratuite"];

const PlanDeMatchPopup = () => {
  const { pathname } = useLocation();
  const [open, setOpen] = useState(false);

  useEffect(() => {
    if (HIDDEN_PREFIXES.some((p) => pathname.startsWith(p))) return;
    if (sessionStorage.getItem(STORAGE_KEY)) return;
    const timer = setTimeout(() => setOpen(true), 3500);
    return () => clearTimeout(timer);
  }, [pathname]);

  const close = () => {
    sessionStorage.setItem(STORAGE_KEY, "1");
    setOpen(false);
  };

  return (
    <AnimatePresence>
      {open && (
        <motion.div
          initial={{ opacity: 0, y: 24, scale: 0.96 }}
          animate={{ opacity: 1, y: 0, scale: 1 }}
          exit={{ opacity: 0, y: 24, scale: 0.96 }}
          transition={{ duration: 0.35, ease: "easeOut" }}
          role="dialog"
          aria-label="Nouveauté : plan de match marketing"
          className="fixed bottom-6 left-6 right-6 sm:right-auto sm:left-6 sm:max-w-sm z-50"
        >
          <div className="relative overflow-hidden rounded-2xl border border-primary/30 bg-card/95 backdrop-blur-xl p-6 shadow-2xl">
            <div className="absolute -top-16 -right-16 h-40 w-40 rounded-full bg-primary/20 blur-3xl" />
            <button
              onClick={close}
              aria-label="Fermer"
              className="absolute top-3 right-3 p-1.5 rounded-lg text-muted-foreground hover:text-foreground hover:bg-secondary transition-colors"
            >
              <X className="w-4 h-4" />
            </button>

            <div className="relative">
              <span className="inline-flex items-center gap-1.5 rounded-full border border-primary/40 bg-primary/10 px-3 py-1 text-xs font-medium text-primary">
                <Sparkles className="w-3 h-3" />
                Nouveauté
              </span>

              <h3 className="mt-4 font-heading text-xl text-foreground leading-snug">
                Bâtir votre <span className="text-primary">plan de match marketing</span> personnalisé
              </h3>
              <p className="mt-2 text-sm text-muted-foreground">
                Un diagnostic complet et un plan clair pour attirer plus de clients, livré en 7 jours.
              </p>

              <Link
                to="/plan-de-match"
                onClick={close}
                className="mt-5 inline-flex items-center gap-2 rounded-full bg-primary px-5 py-2.5 text-sm font-semibold text-primary-foreground transition-transform hover:scale-105 group"
              >
                Découvrir
                <ArrowRight className="w-4 h-4 group-hover:translate-x-1 transition-transform" />
              </Link>
            </div>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};

export default PlanDeMatchPopup;
